import { useEffect, useRef } from 'react';
import { Box, Stack } from '@mui/material';
import ChatMessage from './ChatMessage';

export default function MessageList({ messages, isTyping, onEdit, onDelete }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isTyping]);

  if (!Array.isArray(messages) || messages.length === 0) {
    return null;
  }

  return (
    <Box sx={{ flex: 1, overflowY: 'auto', px: 6, py: 4 }}>
      {messages.map((msg, index) => {
        const isUser = msg.role === 'user';

        return (
          <Stack key={msg.id || index} direction="row" justifyContent={isUser ? 'flex-end' : 'flex-start'} spacing={1.5} mb={2}>
            <ChatMessage content={msg.content} isUser={isUser} message={msg} onEdit={onEdit} onDelete={onDelete} />
          </Stack>
        );
      })}

      {isTyping && (
        <Stack direction="row" spacing={1.5} mb={2}>
          <Box
            sx={{
              px: 2,
              py: 1.3,
              borderRadius: 2,
              bgcolor: 'grey.100',
              fontSize: '0.9rem',
              fontStyle: 'italic',
              color: 'text.secondary'
            }}
            ref={bottomRef}
          >
            Phoenix AI is typing…
          </Box>
        </Stack>
      )}

      <div ref={bottomRef} />
    </Box>
  );
}